import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = { class: "artifact-header" }
const _hoisted_3 = { class: "phase-label" }
const _hoisted_4 = { class: "artifact-body" }
const _hoisted_5 = {
  key: 0,
  class: "artifact-error",
  role: "alert"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "empty-artifact",
  role: "status"
}
const _hoisted_8 = {
  key: 0,
  class: "empty-artifact"
}
const _hoisted_9 = { class: "artifact-symbol" }
const _hoisted_10 = { class: "exam-meta" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "empty-artifact"
}
const _hoisted_13 = { class: "artifact-symbol" }
const _hoisted_14 = { class: "score" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "question-heading",
  tabindex: "-1"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "feedback",
  role: "status"
}
const _hoisted_21 = {
  key: 1,
  class: "artifact-error"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "artifact-navigation" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "artifact-progress"
}
const _hoisted_30 = ["value", "max"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["aria-valuenow"]
const _hoisted_33 = ["aria-label"]
const _hoisted_34 = {
  key: 0,
  class: "guide-tabs",
  role: "tablist",
  "aria-label": "サイドバーの切り替え"
}
const _hoisted_35 = ["aria-selected"]
const _hoisted_36 = ["aria-selected"]
const _hoisted_37 = { class: "guide-content" }
const _hoisted_38 = {
  key: 0,
  class: "inline-progress",
  role: "status"
}
const _hoisted_39 = ["value", "max", "aria-label"]
const _hoisted_40 = {
  key: 1,
  class: "guide-message",
  "aria-live": "polite"
}
const _hoisted_41 = {
  key: 2,
  class: "guide-actions"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "retry-menu-options" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 3,
  class: "practice-notice",
  role: "status"
}
const _hoisted_51 = {
  key: 4,
  class: "question-nav",
  "aria-label": "問題を選ぶ"
}
const _hoisted_52 = ["disabled", "aria-current", "onClick"]
const _hoisted_53 = {
  key: 5,
  class: "guide-keys"
}
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 1,
  class: "artifact-chat"
}
const _hoisted_56 = { class: "chat-heading" }
const _hoisted_57 = {
  key: 2,
  class: "guide-note"
}

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ROUTER_NAME } from '../../router'
import ExamTestQuestionBodyWeb from '../atoms_molecules/ExamTestQuestionBodyWeb.vue'
import ExamResultQuestionBodyWeb from '../atoms_molecules/ExamResultQuestionBodyWeb.vue'
import MesageContainer from './MesageContainer.vue'
import type { ClassroomView } from '../../composables/useClassroomPractice'
import { useExamArtifact } from '../../composables/useExamArtifact'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'
import { notifyParentOfLearningEvent } from '../../learning/learningEventBridge'
import Question from '../../models/question'
import Exam from '../../models/exam'
import LessonPracticeApi from '../../../api/v2/api/lesson_practice'

const GUIDE_DEFAULT = 360, GUIDE_MIN = 280, GUIDE_MAX = 720
const GUIDE_WIDTH_KEY = 'exam-artifact:guide-width'

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamArtifactWorkspace',
  props: {
    examId: {},
    lessonId: {},
    courseId: {},
    inline: { type: Boolean, default: false },
    lessonExam: { type: Boolean, default: false }
  },
  emits: ["active-view", "finished", "discuss"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const schoolSetting = computed(() => headerState.schoolSetting)
const storageKey = computed(() => `exam-artifact:${userState.user?.id}:${props.lessonId}:${props.examId}`)
const router = useRouter()
const route = useRoute()
const activeExamId = ref(props.examId)
const workspaceRef = ref<HTMLElement | null>(null)
// opening：テストを開く準備（受験の用意と読み込み）が終わるまで。終わる前に「テストを始める」などを出さない
const opening = ref(true)
const confirmFinish = ref(false)
const values = ref<Record<number, string[]>>({})
const practiceNotice = ref('')
const { exam, attempt, questions, index, phase, busy, error, groups, answered, count, canReview, remaining, group, loading, load, start, select, submit, finish, retest } = useExamArtifact(() => notifyParentOfLearningEvent('assessment_answered'))
watch(() => [exam.value?.id, attempt.value?.id, phase.value, index.value, busy.value, questions.value], () => {
  emit('active-view', {
    kind: busy.value || !exam.value ? 'loading' : 'exam',
    examId: activeExamId.value, userExamId: attempt.value?.id, phase: phase.value,
    questionIds: ['test', 'feedback', 'review'].includes(phase.value) ? questions.value.map(q => q.id) : [],
    questionNumber: ['test', 'feedback', 'review'].includes(phase.value) ? index.value + 1 : undefined
  })
}, { immediate: true })
// 問題が入れ替わったら、問題の欄を上まで戻す（前の問題でスクロールした位置を引き継がない）
watch(() => questions.value.map(q => q.id).join(','), () => nextTick(() => { const body = workspaceRef.value?.querySelector('.artifact-body'); if (body) body.scrollTop = 0 }))
const phaseLabel = computed(() => ({ ready: '準備', test: 'テスト', feedback: '解説', result: '結果', review: '振り返り' }[phase.value]))
const currentGroupAnswered = computed(() => groups.value[index.value]?.every(q => q.isDescriptionQuestion || q.isAnswered) ?? false)
watch(() => [phase.value, index.value, questions.value, busy.value, opening.value], async () => {
  if (opening.value || phase.value !== 'test' || busy.value || !questions.value.length) return
  await nextTick()
  const fields = workspaceRef.value?.querySelector('.question-fields')
  const first = fields?.querySelector<HTMLElement>('input[type="radio"]:not(:disabled), input[type="checkbox"]:not(:disabled), .textfield-question:not(:disabled), .inline-select-question:not(:disabled), textarea:not(:disabled), select:not(:disabled)')
  const target = first || workspaceRef.value?.querySelector<HTMLElement>('.question-heading')
  target?.focus()
}, { immediate: true, flush: 'post' })
const guideMessage = computed(() => {
  if (phase.value === 'ready') return 'まずは解いてみましょう。結果から、次に取り組む練習を選べます。'
  if (phase.value === 'result') return canReview.value ? '結果が届きました。解説を確認するか、間違えた問題をもう一度試してみましょう。' : '提出を受け付けました。結果の公開・採点をお待ちください。'
  if (phase.value === 'review' || phase.value === 'feedback') return '左側に解答と解説を表示しています。考え方を確かめてみましょう。'
  return `現在は問題${index.value + 1}です。「回答する」を押すと保存されます。`
})
const chatQuestionId = computed(() => (phase.value === 'review' && canReview.value || phase.value === 'feedback') ? questions.value.find(q => !q.isDescriptionQuestion)?.id : undefined)
// サイドバーの幅（px）。受講生がドラッグで変えた幅は、このブラウザに覚えておく
const guideWidth = ref(GUIDE_DEFAULT)
const resizing = ref(false)
function readGuideWidth() { try { return Number(localStorage.getItem(GUIDE_WIDTH_KEY)) || GUIDE_DEFAULT } catch { return GUIDE_DEFAULT } }
// 左の問題の欄が狭くなりすぎないよう、全体の幅の6割までにする
function setGuideWidth(width: number, save = true) {
  const total = workspaceRef.value?.getBoundingClientRect().width || 0
  const max = total ? Math.max(GUIDE_MIN, Math.min(GUIDE_MAX, Math.round(total * 0.6))) : GUIDE_MAX
  guideWidth.value = Math.round(Math.min(max, Math.max(GUIDE_MIN, width)))
  if (save) { try { localStorage.setItem(GUIDE_WIDTH_KEY, String(guideWidth.value)) } catch { /* 保存できなくても幅は変わる */ } }
}
function startResize(event: PointerEvent) {
  const handle = event.currentTarget as HTMLElement
  const right = workspaceRef.value?.getBoundingClientRect().right
  if (right === undefined) return
  event.preventDefault()
  resizing.value = true
  handle.setPointerCapture?.(event.pointerId)
  const move = (e: PointerEvent) => setGuideWidth(right - e.clientX, false)
  const stop = () => {
    resizing.value = false
    handle.removeEventListener('pointermove', move); handle.removeEventListener('pointerup', stop); handle.removeEventListener('pointercancel', stop)
    setGuideWidth(guideWidth.value)
  }
  handle.addEventListener('pointermove', move); handle.addEventListener('pointerup', stop); handle.addEventListener('pointercancel', stop)
}
function resizeWithKeys(event: KeyboardEvent) {
  if (event.altKey || event.metaKey || event.ctrlKey || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return
  event.preventDefault(); event.stopPropagation()
  setGuideWidth(guideWidth.value + (event.key === 'ArrowLeft' ? 24 : -24))
}
// サイドバー：解説を開いているときだけ「AIに相談」のタブを出す。選んだタブは、問題を移っても保つ
const sideTab = ref<'guide' | 'chat'>('guide')
const chatAvailable = computed(() => !props.inline && !!chatQuestionId.value && !!schoolSetting.value?.useAiChatExam)
const showChat = computed(() => chatAvailable.value && sideTab.value === 'chat')
// AIに、いま開いている受験（どの回の回答か）を伝える。伝えないと、過去の回の回答まで混ざる
const chatView = computed<ClassroomView>(() => ({ kind: 'exam', examId: activeExamId.value, userExamId: attempt.value?.id, phase: phase.value, questionIds: questions.value.map(q => q.id) }))
const retryMenu = ref<HTMLDetailsElement | null>(null)
async function chooseRetry(action: () => Promise<void>) {
  if (retryMenu.value) retryMenu.value.open = false
  await action()
}
function changeValue(value: string[], question: Question) { values.value[question.id] = value }
function saveAnswer() {
  questions.value.forEach(q => {
    if (q.isTextfield || q.isInlineSelect) {
      const selector = q.isTextfield ? '.textfield-question' : '.inline-select-question'
      values.value[q.id] = Array.from(document.getElementById(`question_${q.id}`)?.querySelectorAll<HTMLInputElement>(selector) || []).map(el => el.value)
    }
  })
  submit(values.value)
}
function nextQuestion() {
  if (index.value + 1 < groups.value.length) select(index.value + 1, phase.value === 'review')
  else if (phase.value === 'review') phase.value = 'result'
  else confirmFinish.value = true
}
function onShortcut(event: KeyboardEvent) {
  if (!busy.value && phase.value === 'test' && !event.metaKey && !event.ctrlKey && !event.altKey &&
      (event.key === 'ArrowDown' || event.key === 'ArrowUp') && event.target instanceof HTMLInputElement &&
      (event.target.type === 'radio' || event.target.type === 'checkbox')) {
    const container = event.target.closest('.radio-component, .checkbox-component')
    const choices = Array.from(container?.querySelectorAll<HTMLInputElement>(`input[type="${event.target.type}"]:not(:disabled)`) || [])
    const position = choices.indexOf(event.target)
    if (position >= 0 && choices.length > 1) {
      event.preventDefault()
      const next = choices[(position + (event.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length]
      next.focus()
      if (next.type === 'radio') next.click()
    }
    return
  }
  if (event.target instanceof Element && event.target.closest('#chat-container')) return
  // Option(Alt)+←/→：問題を移動（テスト中・解説・振り返りのどれでも）。文字を入力する欄では、単語単位のカーソル移動を奪わない
  if (!busy.value && event.altKey && !event.metaKey && !event.ctrlKey && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
    if (!['test', 'feedback', 'review'].includes(phase.value) || isTextEntry(event.target)) return
    const next = index.value + (event.key === 'ArrowRight' ? 1 : -1)
    if (next < 0 || next >= groups.value.length) return
    event.preventDefault()
    event.stopPropagation()
    select(next, phase.value === 'review')
    return
  }
  if (busy.value || !(event.metaKey || event.ctrlKey)) return
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault()
    event.stopPropagation()
    if (phase.value === 'ready') start()
    else if (phase.value === 'test' && remaining.value > 0 && !group.value.isDescriptionQuestion && !currentGroupAnswered.value) saveAnswer()
    else if (phase.value === 'result') { if (canReview.value) select(0, true) }
    else nextQuestion()
  } else if (event.shiftKey && event.key === 'ArrowRight' && index.value + 1 < groups.value.length) {
    event.preventDefault()
    select(index.value + 1, phase.value === 'review')
  } else if (event.shiftKey && event.key === 'ArrowLeft' && index.value > 0) {
    event.preventDefault()
    select(index.value - 1, phase.value === 'review')
  }
}
function isTextEntry(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) return false
  if (target instanceof HTMLTextAreaElement || target.isContentEditable) return true
  return target instanceof HTMLInputElement && !['radio', 'checkbox', 'button', 'submit'].includes(target.type)
}
// 解説や結果の画面ではボタンが入れ替わってフォーカスがページに戻るので、ワークスペースの外で押されたキーも拾う。
// ワークスペースの中で押されたキーは上の @keydown が処理する（二重に動かさない）。ほかの入力欄・チャット・隠れているときは何もしない
function onWindowShortcut(event: KeyboardEvent) {
  const el = workspaceRef.value
  if (!el || !el.isConnected) return
  if (event.target instanceof Node && el.contains(event.target)) return
  if (event.target instanceof Element && event.target.closest('input, textarea, select, [contenteditable="true"], #chat-container, .v-overlay')) return
  for (let node: HTMLElement | null = el; node; node = node.parentElement) if (node.style.display === 'none') return
  onShortcut(event)
}
onMounted(() => { window.addEventListener('keydown', onWindowShortcut); setGuideWidth(readGuideWidth(), false) })
onBeforeUnmount(() => window.removeEventListener('keydown', onWindowShortcut))
function remember() { localStorage.setItem(storageKey.value, String(activeExamId.value)) }
async function reload() { await load(activeExamId.value) }
async function finishExam() { confirmFinish.value = false; await finish(); if (phase.value === 'result') emit('finished') }
async function createRetest() {
  const id = await retest(String(Exam.TYPE_USE_EXAM_FROM_FAILED))
  if (id) { activeExamId.value = id; remember(); practiceNotice.value = '前回の間違いから、あなた専用のテストを作りました。' }
}
// 元のテストを最初からもう一度（間違えた問題だけのテストを開いているときも、元のテストに戻って全問）
async function createFullRetest() {
  const id = await retest('', props.examId)
  if (id) { activeExamId.value = id; remember(); practiceNotice.value = 'すべての問題を、もう一度最初から解けます。' }
}
// マイテストの「今までのテスト結果」（再テストの回ごとの結果）を開く
function openHistories() {
  // return_to：結果の一覧の「戻る」で、このレッスンに戻る
  router.push({ name: ROUTER_NAME.MY_EXAM_LIST, query: { exam_id: String(props.examId), return_to: route?.fullPath } })
}
async function returnToOriginal() { activeExamId.value = props.examId; remember(); practiceNotice.value = ''; await reload() }
watch(() => [props.examId, props.lessonId], async () => {
  opening.value = true
  activeExamId.value = Number(localStorage.getItem(storageKey.value)) || props.examId
  try {
    if (props.lessonExam) {
      try { await new LessonPracticeApi().ensureExamSession(props.lessonId, props.courseId) }
      catch (e: any) { error.value = typeof e?.messages === 'string' ? e.messages : 'テストを開けませんでした。'; return }
    }
    await reload()
  } finally { opening.value = false }

}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("section", {
    ref_key: "workspaceRef",
    ref: workspaceRef,
    class: _normalizeClass(['exam-workspace', { 'artifact-only': __props.inline, resizing: resizing.value }]),
    style: _normalizeStyle(__props.inline ? undefined : { '--guide-width': `${guideWidth.value}px` }),
    "aria-label": "試験の学習ワークスペース",
    onKeydownCapture: onShortcut
  }, [
    _createElementVNode("main", {
      class: "exam-artifact",
      "aria-busy": _unref(busy)
    }, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "eyebrow" }, "学習ワークスペース", -1 /* CACHED */)),
          _createElementVNode("h2", null, _toDisplayString(_unref(exam)?.name || 'テスト'), 1 /* TEXT */)
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(phaseLabel.value), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(error))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(error)), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: reload,
                disabled: _unref(busy)
              }, "読み直す", 8 /* PROPS */, _hoisted_6)
            ]))
          : _createCommentVNode("v-if", true),
        (opening.value || _unref(loading) || (_unref(busy) && !_unref(exam)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "テストを読み込んでいます…"))
          : (_unref(exam))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_unref(phase) === 'ready')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_v_icon, { size: "32" }, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode("mdi-pencil-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("h3", null, "ここから、理解を確かめましょう。", -1 /* CACHED */)),
                      _createElementVNode("p", null, _toDisplayString(_unref(exam).description || '問題に取り組み、結果から次の練習へ進めます。'), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_10, "制限時間 " + _toDisplayString(_unref(exam).timeLimit) + "分 · 「回答する」で保存", 1 /* TEXT */),
                      _createElementVNode("button", {
                        class: "primary-action",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(start) && _unref(start)(...args))),
                        disabled: _unref(busy)
                      }, [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("テストを始める ", -1 /* CACHED */),
                        _createElementVNode("span", null, "→", -1 /* CACHED */)
                      ]))], 8 /* PROPS */, _hoisted_11)
                    ]))
                  : (_unref(phase) === 'result')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_v_icon, { size: "32" }, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode("mdi-check", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _createElementVNode("h3", null, _toDisplayString(_unref(canReview) ? 'おつかれさまでした。' : 'テストを提出しました。'), 1 /* TEXT */),
                        (_unref(canReview))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createTextVNode(_toDisplayString(Math.round(_unref(attempt)?.average || 0)), 1 /* TEXT */),
                                _cache[24] || (_cache[24] = _createElementVNode("small", null, "%", -1 /* CACHED */))
                              ]),
                              _cache[25] || (_cache[25] = _createElementVNode("p", null, "解答と解説を振り返り、次の練習を選べます。", -1 /* CACHED */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(exam).hideResult ? 'このテストの結果は公開されていません。' : '採点結果を確認しています。時間をおいて読み直してください。'), 1 /* TEXT */)),
                        (_unref(canReview))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "primary-action",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(select)(0, true))),
                              disabled: _unref(busy)
                            }, "解答と解説を見る →", 8 /* PROPS */, _hoisted_16))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "secondary-action",
                              onClick: reload,
                              disabled: _unref(busy)
                            }, "結果を読み直す", 8 /* PROPS */, _hoisted_17))
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", null, "問題 " + _toDisplayString(_unref(index) + 1) + " / " + _toDisplayString(_unref(groups).length), 1 /* TEXT */),
                          (!_unref(attempt)?.finishedAt)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "残り " + _toDisplayString(Math.floor(_unref(remaining) / 60)) + ":" + _toDisplayString(String(_unref(remaining) % 60).padStart(2, '0')), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (_unref(phase) === 'feedback')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(group).userScore === _unref(group).maxScore ? '正解です。次の問題へ進みましょう。' : '解説で確かめてから、次へ進みましょう。'), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (!_unref(remaining) && !_unref(attempt)?.finishedAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, "制限時間です。テストを提出してください。"))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("fieldset", {
                          disabled: _unref(busy) || (!_unref(remaining) && !_unref(attempt)?.finishedAt),
                          class: "question-fields"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questions), (q, qi) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `${_unref(attempt)?.id}-${q.id}-${_unref(phase)}`
                            }, [
                              (_unref(phase) === 'review' || _unref(phase) === 'feedback')
                                ? (_openBlock(), _createBlock(ExamResultQuestionBodyWeb, {
                                    key: 0,
                                    id: `question_${q.id}`,
                                    exam: _unref(exam),
                                    "user-exam": _unref(attempt),
                                    "current-question": q,
                                    "group-index": _unref(index) + 1,
                                    index: qi + 1,
                                    "school-setting": schoolSetting.value,
                                    "is-multiple-question": _unref(questions).length > 1
                                  }, null, 8 /* PROPS */, ["id", "exam", "user-exam", "current-question", "group-index", "index", "school-setting", "is-multiple-question"]))
                                : (_openBlock(), _createBlock(ExamTestQuestionBodyWeb, {
                                    key: 1,
                                    id: `question_${q.id}`,
                                    exam: _unref(exam),
                                    "current-question": q,
                                    index: qi,
                                    time: _unref(remaining),
                                    onChangeValue: changeValue
                                  }, null, 8 /* PROPS */, ["id", "exam", "current-question", "index", "time"]))
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_22),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("button", {
                            class: "secondary-action",
                            disabled: _unref(busy) || _unref(index) === 0,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(select)(_unref(index) - 1, _unref(phase) === 'review')))
                          }, "← 前へ", 8 /* PROPS */, _hoisted_24),
                          (_unref(phase) === 'test' && !_unref(group).isDescriptionQuestion && !currentGroupAnswered.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "primary-action",
                                disabled: _unref(busy) || !_unref(remaining),
                                onClick: saveAnswer
                              }, "回答する", 8 /* PROPS */, _hoisted_25))
                            : _createCommentVNode("v-if", true),
                          (_unref(index) + 1 < _unref(groups).length)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "secondary-action",
                                disabled: _unref(busy),
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(select)(_unref(index) + 1, _unref(phase) === 'review')))
                              }, "次の問題 →", 8 /* PROPS */, _hoisted_26))
                            : (_unref(phase) === 'review')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "primary-action",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (phase.value = 'result'))
                                }, "結果に戻る"))
                              : (_unref(phase) !== 'test' || _unref(group).isDescriptionQuestion || currentGroupAnswered.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    class: "primary-action",
                                    disabled: _unref(busy),
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (confirmFinish.value = true))
                                  }, "提出して結果を見る", 8 /* PROPS */, _hoisted_27))
                                : _createCommentVNode("v-if", true)
                        ])
                      ], 64 /* STABLE_FRAGMENT */)),
                (__props.inline && !__props.lessonExam && _unref(canReview) && _unref(attempt))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "secondary-action discussion-action",
                      disabled: _unref(busy),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('discuss', _unref(attempt).id)))
                    }, "結果についてチャットで確認する →", 8 /* PROPS */, _hoisted_28))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
      ]),
      (!__props.inline && _unref(count) && !_unref(attempt)?.finishedAt)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_29, [
            _createElementVNode("progress", {
              value: _unref(answered),
              max: _unref(count)
            }, null, 8 /* PROPS */, _hoisted_30),
            _createElementVNode("span", null, _toDisplayString(_unref(answered)) + " / " + _toDisplayString(_unref(count)) + " 回答済み", 1 /* TEXT */),
            _createElementVNode("button", {
              disabled: _unref(busy),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (confirmFinish.value = true))
            }, "提出する", 8 /* PROPS */, _hoisted_31)
          ]))
        : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_1),
    _createCommentVNode(" サイドバーの幅を変えるつまみ：ドラッグ、または ←/→ キー。ダブルクリックで元の幅に戻す "),
    (!__props.inline)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "guide-resizer",
          role: "separator",
          "aria-orientation": "vertical",
          tabindex: "0",
          "aria-valuenow": guideWidth.value,
          "aria-valuemin": GUIDE_MIN,
          "aria-valuemax": GUIDE_MAX,
          "aria-label": "サイドバーの幅を変える",
          title: "ドラッグで幅を変える（ダブルクリックで元に戻す）",
          onPointerdown: startResize,
          onKeydown: resizeWithKeys,
          onDblclick: _cache[8] || (_cache[8] = ($event: any) => (setGuideWidth(GUIDE_DEFAULT)))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_32))
      : _createCommentVNode("v-if", true),
    _createElementVNode("aside", {
      class: _normalizeClass(['learning-guide', { 'inline-guide': __props.inline }]),
      "aria-label": __props.inline ? '問題一覧と進捗' : '次の学習とチャット'
    }, [
      _createElementVNode("header", null, [
        _createVNode(_component_v_icon, { size: "22" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.inline ? 'mdi-format-list-numbered' : 'mdi-compass-outline'), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("strong", null, _toDisplayString(__props.inline ? '問題一覧' : '学習ガイド'), 1 /* TEXT */)
      ]),
      _createCommentVNode(" チャットが使えるとき（解説を開いているとき）は、タブで切り替える。チャットはサイドバーいっぱいに広げる "),
      (chatAvailable.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("button", {
              type: "button",
              role: "tab",
              "aria-selected": sideTab.value === 'guide',
              class: _normalizeClass({ active: sideTab.value === 'guide' }),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (sideTab.value = 'guide'))
            }, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createTextVNode("mdi-format-list-checks", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _cache[27] || (_cache[27] = _createTextVNode("次にやること", -1 /* CACHED */))
            ], 10 /* CLASS, PROPS */, _hoisted_35),
            _createElementVNode("button", {
              type: "button",
              role: "tab",
              "aria-selected": sideTab.value === 'chat',
              class: _normalizeClass({ active: sideTab.value === 'chat' }),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (sideTab.value = 'chat'))
            }, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode("mdi-chat-question-outline", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _cache[29] || (_cache[29] = _createTextVNode("AIに相談", -1 /* CACHED */))
            ], 10 /* CLASS, PROPS */, _hoisted_36)
          ]))
        : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("div", _hoisted_37, [
        (__props.inline && _unref(count))
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(Math.round(_unref(answered) * 100 / _unref(count))) + "%", 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString(_unref(answered)) + " / " + _toDisplayString(_unref(count)) + " 回答済み", 1 /* TEXT */)
              ]),
              _createElementVNode("progress", {
                value: _unref(answered),
                max: _unref(count),
                "aria-label": `回答の進捗 ${_unref(answered)} / ${_unref(count)}`
              }, null, 8 /* PROPS */, _hoisted_39)
            ]))
          : _createCommentVNode("v-if", true),
        (!__props.inline && !opening.value && !_unref(loading))
          ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(guideMessage.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (!__props.inline && !opening.value && !_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              (_unref(phase) === 'ready')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(start) && _unref(start)(...args))),
                    disabled: _unref(busy)
                  }, [...(_cache[30] || (_cache[30] = [
                    _createTextVNode("このテストに取り組む ", -1 /* CACHED */),
                    _createElementVNode("span", null, "↗", -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_42))
                : _createCommentVNode("v-if", true),
              (_unref(canReview))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" 主役は1つ：結果の画面では「振り返る」。解説を見ているときは、もう押す必要がないので出さない "),
                    (_unref(phase) === 'result')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "guide-primary",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(select)(0, true))),
                          disabled: _unref(busy)
                        }, [...(_cache[31] || (_cache[31] = [
                          _createTextVNode("解答と解説を振り返る ", -1 /* CACHED */),
                          _createElementVNode("span", null, "↗", -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_43))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" テスト形式のレッスン：やり直し方は1つのメニューにまとめる（以前の「再テストなど」と同じ3つ） "),
                    (__props.lessonExam && _unref(exam)?.canRetest)
                      ? (_openBlock(), _createElementBlock("details", {
                          key: 1,
                          ref_key: "retryMenu",
                          ref: retryMenu,
                          class: "retry-menu"
                        }, [
                          _cache[34] || (_cache[34] = _createElementVNode("summary", null, [
                            _createTextVNode("もう一度解く "),
                            _createElementVNode("span", { "aria-hidden": "true" }, "⌄")
                          ], -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (chooseRetry(createRetest))),
                              disabled: _unref(busy)
                            }, [...(_cache[32] || (_cache[32] = [
                              _createTextVNode("間違えた問題だけ", -1 /* CACHED */),
                              _createElementVNode("small", null, "前回まちがえた問題から、あなた専用のテストを作ります", -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_45),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (chooseRetry(createFullRetest))),
                              disabled: _unref(busy)
                            }, [...(_cache[33] || (_cache[33] = [
                              _createTextVNode("すべての問題", -1 /* CACHED */),
                              _createElementVNode("small", null, "同じテストを最初から解き直します", -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_46)
                          ])
                        ], 512 /* NEED_PATCH */))
                      : (_unref(exam)?.canRetest)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: createRetest,
                            disabled: _unref(busy)
                          }, [...(_cache[35] || (_cache[35] = [
                            _createTextVNode("間違えた問題をもう一度 ", -1 /* CACHED */),
                            _createElementVNode("span", null, "↗", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_47))
                        : _createCommentVNode("v-if", true),
                    (__props.lessonExam)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          type: "button",
                          class: "guide-link",
                          onClick: openHistories,
                          disabled: _unref(busy)
                        }, "今までのテスト結果を見る", 8 /* PROPS */, _hoisted_48))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (_unref(attempt)?.startedAt && !_unref(attempt).finishedAt)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (confirmFinish.value = true)),
                    disabled: _unref(busy)
                  }, [...(_cache[36] || (_cache[36] = [
                    _createTextVNode("提出して結果を見る ", -1 /* CACHED */),
                    _createElementVNode("span", null, "↗", -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_49))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        (practiceNotice.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(practiceNotice.value), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_unref(groups).length)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_51, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (g, gi) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: g[0].id,
                  class: _normalizeClass({ active: gi === _unref(index) && _unref(phase) !== 'result', answered: g.every(q => q.isAnswered || q.isDescriptionQuestion) }),
                  disabled: _unref(busy) || _unref(phase) === 'ready' || _unref(phase) === 'result' && !_unref(canReview),
                  "aria-current": gi === _unref(index) && _unref(phase) !== 'result' ? 'step' : undefined,
                  onClick: ($event: any) => (_unref(select)(gi, !!_unref(attempt)?.finishedAt))
                }, [
                  (__props.inline)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", null, "問題 " + _toDisplayString(gi + 1), 1 /* TEXT */),
                        _createElementVNode("small", null, _toDisplayString(g.every(q => q.isAnswered || q.isDescriptionQuestion) ? '回答済み' : '未回答'), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(gi + 1), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ], 10 /* CLASS, PROPS */, _hoisted_52))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        (_unref(groups).length && _unref(phase) !== 'ready' && _unref(phase) !== 'result')
          ? (_openBlock(), _createElementBlock("p", _hoisted_53, "⌘/Ctrl+Enter：次へ　Option/Alt+←→：問題を移動"))
          : _createCommentVNode("v-if", true),
        (__props.inline && _unref(attempt)?.startedAt && !_unref(attempt).finishedAt)
          ? (_openBlock(), _createElementBlock("button", {
              key: 6,
              class: "inline-submit",
              disabled: _unref(busy),
              onClick: _cache[16] || (_cache[16] = ($event: any) => (confirmFinish.value = true))
            }, "テストを提出する", 8 /* PROPS */, _hoisted_54))
          : _createCommentVNode("v-if", true),
        (!__props.inline && activeExamId.value !== __props.examId && !_unref(busy) && (!_unref(attempt)?.startedAt || _unref(attempt).finishedAt))
          ? (_openBlock(), _createElementBlock("button", {
              key: 7,
              class: "return-link",
              onClick: returnToOriginal
            }, "元のテストに戻る"))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */), [
        [_vShow, !showChat.value]
      ]),
      (chatAvailable.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, "問題 " + _toDisplayString(_unref(index) + 1) + " について相談（あなたの今回の回答と解説をAIが読んでいます）", 1 /* TEXT */),
            (_openBlock(), _createBlock(MesageContainer, {
              key: `${_unref(attempt)?.id}-${chatQuestionId.value}`,
              "targetable-id": chatQuestionId.value,
              "targetable-type": "Question",
              "using-deepseek": schoolSetting.value.usingDeepSeek,
              "active-view": chatView.value
            }, null, 8 /* PROPS */, ["targetable-id", "using-deepseek", "active-view"]))
          ], 512 /* NEED_PATCH */)), [
            [_vShow, showChat.value]
          ])
        : (!__props.inline)
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_unref(attempt)?.finishedAt ? '解説を開くと、その問題について相談できます。' : '回答・採点・復習まで、この画面で進められます。'), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_33),
    _createVNode(_component_v_dialog, {
      modelValue: confirmFinish.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((confirmFinish).value = $event)),
      "max-width": "440"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                _createTextVNode("テストを提出しますか？", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("回答済み " + _toDisplayString(_unref(answered)) + " / " + _toDisplayString(_unref(count)) + "問。提出後は今回の回答を変更できません。", 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (confirmFinish.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("戻る", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: finishExam,
                  disabled: _unref(busy)
                }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode("提出する", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 38 /* CLASS, STYLE, NEED_HYDRATION */))
}
}

})